module.exports = __webpack_public_path__ + "static/media/cover_Profile.112d1926.png";